import { IComponentOptions } from "angular";
import { SingleMachineDecommissionComponentController } from "./controller";

export const vsComponentName = "machineDecommission";
export const singleMachineDecommissionComponentOptions: IComponentOptions = {
  controller: SingleMachineDecommissionComponentController,
  controllerAs: "singleMachineDecommissionComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machine: "<",
  },
};
